/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Tax scheme applied to the shop. When set to KLEINUNTERNEHMEN or DIFFERENZBESTEUERT, a legally compliant note is automatically appended to the invoice / credit-note footer.
 * @export
 * @enum {string}
 */

export enum TaxScheme {
    None = 'NONE',
    Kleinunternehmen = 'KLEINUNTERNEHMEN',
    Differenzbesteuert = 'DIFFERENZBESTEUERT'
}



